import React from "react";
import _ from "lodash";

import { Post } from "./Post";
import { NotFound } from "../NotFound/NotFound";
import { useArchiveContext } from "../../context/archive.context";

export const PostList = ({ posts, fetchNextPage, discoverMore = true, disabledButton = false }) => {

	const { lang } = useArchiveContext();

	const isArabic = lang.toLowerCase().includes("ar");
	return (
		<div className="ResourcesListArticles">
			{posts && posts.length ? (
				<>
					<div className="main-container post-list">
						{_.map(posts, (item) => (
							<Post key={item.id} data={item} />
						))}
					</div>

					{discoverMore && (
						<div className="mp-button">
							<button
								className="MuiButtonBase-root jss216 jss153"
								tabIndex="0"
								role="button"
								aria-disabled={disabledButton}
								href="#"
								style={{
									width: 200,
									height: 70,
									fontSize: "14px",
									opacity: disabledButton?"0.5":"1",
									cursor: disabledButton?"no-drop":"pointer",
								}}
								disabled={disabledButton}
								onClick={fetchNextPage}
							>
								<div
									className="mp-button-value"
									style={{ zIndex: 2, pointerEvents: "none" }}
								>
								 {isArabic ?  "إكتشف أكثر" : "Discover more"}	
								</div>
								<svg
									style={{
										// backgroundImage: `url(${ButtonBg})`,
										position: "absolute",
										width: 200,
										height: 70,
									}}
									preserveAspectRatio="none"
									width="200"
									height="70"
									viewBox="0 0 200 70"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M61.9525 69.9459C74.24 70.3011 170.234 69.0902 178.596 60.7575C186.824 52.5594 197.744 51.9045 199.107 40.7196C200.105 32.529 201.179 34.6459 196.831 27.2603C192.186 19.3717 179.424 9.39796 171.825 5.16051C156.875 -3.17513 29.7065 -0.910978 18.2677 8.35388C-5.26212 27.4119 -5.40305 44.6019 14.0585 61.2769C23.6636 68.4902 49.6642 69.5907 61.9525 69.9459Z"
										fill="#201F57"
									/>
								</svg>
							</button>
						</div>
					)}
				</>
			) : (
				<NotFound />
			)}
		</div>
	);
};
